import Cookies from 'js-cookie';
import { LangHelper } from 'utils/LangHelper';
import { UTM } from 'utils/UTM';

import { TestParams } from 'TestParams';

const { hostname, pathname, href } = window.location;

// Classification from https://en.wikipedia.org/wiki/Deployment_environment
const isProductionHost = /(^|\.)mcs\.mail\.ru$/.test(hostname);
const isStagingHost = /(^|\.)mcstest\.mail\.ru$/.test(hostname);
const isTestingHost = /(^|\.)mcs(\d?)\.devmail\.ru$/.test(hostname);
const isDevelopmentHost = /^local\./.test(hostname);
const isLandings = !/^\/(partner\/)?app\b/.test(pathname);
const isPrivateBuild = process.env.IS_PRIVATE_BUILD;
const isBeta = Cookies.get('mcsbeta') === '1';

type EnvId = 'prod' | 'stage' | 'test' | 'dev';
const envId: EnvId = isProductionHost
    ? 'prod'
    : isStagingHost
    ? 'stage'
    : isTestingHost
    ? 'test'
    : 'dev';

const isDevBuild = process.env.NODE_ENV === 'development';
const isProdBuild = process.env.NODE_ENV === 'production';

export const Environment = {
    lang: LangHelper.getLangOnAppLoaded(isLandings),

    envId,

    isProductionHost,
    isStagingHost,
    isTestingHost,
    isDevelopmentHost,
    isDefaultDevelopmentHost: hostname === 'local.mcs.devmail.ru',
    isLandings,
    isPrivateBuild: Boolean(isPrivateBuild),
    isBeta,

    isAutoTesting: TestParams.isAutoTesting,
    marketplaceBucket: TestParams.marketplaceBucket,

    isProductionRun: !isDevelopmentHost && isProductionHost,
    isStagingRun: !isDevelopmentHost && isStagingHost,
    isTestingRun: !isDevelopmentHost && isTestingHost,
    isDevelopmentRun: isDevelopmentHost,

    utmParams: UTM.parse(href),

    isDevBuild,
    isProdBuild,
};
